import React from 'react';

import classes from './Quote.module.scss';


const Quote = ({content, author, windowSize}) => {
	
	return(
		<div className={`container `}>
			<div className={`row`}>
				<div className={`col-lg-8 ${classes.Quote}`}>
					<div className={classes.Quote__copyContainer}>
						{/* <h3 className={classes.Quote__copy} dangerouslySetInnerHTML={{__html:content.copy+" "+content.writtenBy+" "+author.name}}></h3> */}
						<h3 className={classes.Quote__copy} dangerouslySetInnerHTML={{__html:content.copy}}></h3>
					</div>
				</div>
			</div>
          
		</div>
	)

}

export default Quote;